<div  style="background-image: url('assets/images/Vector.png');
background-color: rgba(35, 113, 211, 0.03); min-height: 100vh;">
<div class="heading-top d-flex">
    <div class="pt-1 ml-3 sm-22">
        <!-- <i class="fas fa-home pt-1 mr-2 color-blue"></i> -->
        <svg class="pt-2 mr-3" width="18" height="29" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.848 16.498C15.2076 16.4969 15.4989 16.2056 15.5 15.846V7.49799C15.4885 7.29437 15.3984 7.10317 15.2487 6.96465L8 1.49799L0.751333 6.96465C0.601642 7.10317 0.51154 7.29437 0.5 7.49799V15.846C0.501098 16.2056 0.792366 16.4969 1.152 16.498H14.848Z" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="gilroy-bold color-royalblue">Home</span>
    </div>
</div>
<div class="head-top small">
    <div class="w-100">
        <ul class="nav nav-tabs border-0" id="myTab" role="tablist">
            <li class="nav-item">
                <a class="nav-link active border-0 bg-transparent sm-12" id="recent-tab" data-toggle="tab" href="#recent" role="tab" aria-controls="recent" aria-selected="true">Recent activity</a>
            </li>
            <li class="nav-item ">
                <a class="nav-link border-0 bg-transparent sm-12" id="transaction-tab" data-toggle="tab" href="#transaction" role="tab" aria-controls="transaction" aria-selected="false">Transaction history</a>
            </li>
            <!-- <li class="nav-item ">
                <a class="nav-link border-0 bg-transparent sm-12" id="request-tab" data-toggle="tab" href="#requests" role="tab" aria-controls="requests" aria-selected="false">Request history</a>
            </li> -->
        </ul>
    </div>
    <div class="row tab-content mx-0 ">
        
        <div class="col-md-5 col-12 tab-pane fade show active" role="tabpanel" 
        id="recent"  aria-labelledby="recent-tab">
        <div *ngIf="auth.user?.email_verified_at" class="card border-0 verified-box d-flex align-items-between radius-5 py-2 my-2 mx-0">
            <div class="d-flex justify-content-between align-items-center p-3">
                <div class="gilroy-bold pt-1 sm-10 color-green">
                    <img src="assets/images/key_green.PNG"  alt="Verification" class="mr-1" width="24px">
                    <!-- <i class="fa fa-money p-0 sm-16 mr-1"></i> -->
                    Verification
                </div>
                <div class="text-secondary sm-10">
                    <!-- {{auth.user.email_verified_at | date}} -->
                    {{ common.carbonToJs(auth.user.email_verified_at) }}
                </div>
            </div>
            <div class="d-flex justify-content-between p-3">
                <div class="sm-12 color-green gilroy-bold">Your email is verified</div>
            </div>
        </div>
        <div *ngIf="auth.user?.email_verified_at && auth.user.mob_verified && auth.user.country_id==39" class="card border-0 verified-box d-flex align-items-between radius-5 py-2 my-2 mx-0">
            <div class="d-flex justify-content-between align-items-center p-3">
                <div class="gilroy-bold pt-1 sm-10 color-green">
                    <img src="assets/images/key_green.PNG"  alt="Verification" class="mr-1" width="24px">
                    <!-- <i class="fa fa-money p-0 sm-16 mr-1"></i> -->
                    Verification
                </div>
                <div class="lightGrey-text sm-10">
                    <!--  {{auth.user.email_verified_at | date}} -->
                    {{ common.carbonToJs(auth.user.email_verified_at) }}
                    
                </div>
            </div>
            <div class="d-flex justify-content-between p-3 align-items-center">
                <div class="sm-12 color-green gilroy-bold">Your mobile number is verified</div>
                <div *ngIf="!auth.user?.verified">
                    <button  class="btn primary-btn px-3 btn-widthFull sm-12" routerLink="/send-money">N2XGo</button>
                </div>
            </div>
        </div>
        <div *ngIf="auth.user?.email_verified_at && !auth.user?.verified && !auth.documents?.length" class="card border-0 verified-box d-flex align-items-between radius-5 py-2 my-2 mx-0">
            <div class="d-flex justify-content-between align-items-center p-3">
                <div class="gilroy-bold pt-1 sm-10 color-blue">
                    <img src="assets/images/key.png" alt="Verification" class="mr-1" width="16px">
                    Verification
                </div>
                <div class="lightGrey-text sm-10">
                    <!--  {{auth.user.email_verified_at | date}} -->
                </div>
            </div>
            <div class="d-flex justify-content-between p-3 align-items-center">
                <div class="sm-12 color-blue gilroy-bold">Your account is pending verification. Kindly upload documents to avail add on functionalities.</div>
                <div>
                    <button  class="btn primary-btn px-3 btn-widthFull sm-12" routerLink="/upload-document">Upload documents</button>
                </div>
            </div>
        </div>
        <div *ngIf="auth.user?.email_verified_at && !auth.user?.verified && auth.documents?.length>0" class="card border-0 verified-box d-flex align-items-between radius-5 py-2 my-2 mx-0">
            <div class="d-flex justify-content-between align-items-center p-3">
                <div class="gilroy-bold pt-1 sm-10 color-blue">
                    <img src="assets/images/key.png" alt="Verification" class="mr-1" width="16px">
                    Verification
                </div>
                <div class="lightGrey-text sm-10">
                    <!--  {{auth.user.email_verified_at | date}} -->
                </div>
            </div>
            <div class="d-flex justify-content-between p-3 align-items-center">
                <div class="sm-12 color-blue gilroy-bold">Your documents are pending verification</div>
                <div>
                    <button  class="btn primary-btn px-3 btn-widthFull sm-12" routerLink="/upload-document">View</button>
                </div>
            </div>
        </div>
        <div *ngIf="auth.user?.email_verified_at && auth.user.verified" class="card border-0 verified-box d-flex align-items-between radius-5 py-2 my-2 mx-0">
            <div class="d-flex justify-content-between align-items-center p-3">
                <div class="gilroy-bold pt-1 sm-10 color-green">
                    <img src="assets/images/key_green.PNG"  alt="Verification" class="mr-1" width="24px">
                    <!-- <i class="fa fa-money p-0 sm-16 mr-1"></i> -->
                    Verification
                </div>
                <div class="lightGrey-text sm-10">
                    <!--  {{auth.user.email_verified_at | date}} -->
                    {{ common.carbonToJs(auth.user.email_verified_at) }}
                    
                </div>
            </div>
            <div class="d-flex justify-content-between p-3 align-items-center">
                <div class="sm-12 color-green gilroy-bold">Your account is verified</div>
                <div>
                    <button  class="btn primary-btn px-3 btn-widthFull sm-12" routerLink="/send-money">Send money</button>
                </div>
            </div>
        </div>
        
    </div>
    
    
    
    <div class="col-md-5 col-12 tab-pane fade " role="tabpanel" 
    id="transaction"  aria-labelledby="transaction-tab">
    <div class="modal fade" id="us-invoice" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title w-100 text-center" id="exampleModalLabel">Invoice Details</h5>
                    <button type="button" class="close close-modal" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div id="widget-root"></div>
                </div>
            </div>
        </div>
    </div>
    <ng-container *ngIf="!transactions.length">
        <span class="text-center">No transactions</span>
    </ng-container>
    <div *ngFor="let transaction of transactions" class="card border-0 verified-box d-flex align-items-between radius-5 py-2 my-2 mx-0">
        <!-- initiated -> yellow -> processing
            under_process -> yellow -> pending
            success -> green -> successful
            COMPLETED -> green -> completed
            HOLD -> success -> on hold
            CANCEL_UNDER_PROCESS -> green -> cancelled (under progress)
            cancelled -> red -> cancelled
            failed -> red -> failed
        -->
            <ng-container *ngIf="transaction.status=='initiated'">
                <div class="d-flex justify-content-between align-items-center p-3">
                    <div class="gilroy-bold pt-1 sm-10 color-green">
                        <img src="assets/images/send_money_blue.PNG" alt="Send Money" class="mr-1" width="24px">
                        <!-- <i class="fa fa-money p-0 sm-16 mr-1"></i> -->
                        Send money
                    </div>
                    <div class="text-secondary sm-10">
                        
                        {{ common.carbonToJs(transaction.created) }} 
                        
                    </div>
                    <div class="gilroy-bold sm-10 text-warning">
                        PROCESSING 
                    </div>
                </div>
                <div class="d-flex justify-content-between p-3 align-items-center">
                    <div class="sm-12 gilroy-med col-md-8 col-6">
                        You are sending <span class="gilroy-bold color-green">{{ transaction.receiver_amt }} {{ transaction.receiver_currency }}</span> to <span class="gilroy-bold color-green">{{ transaction.first_name ? transaction.first_name : transaction.name}} {{ transaction.last_name }}</span>
                    </div>
                    <!-- <div>
                        <button  class="btn primary-btn px-3 btn-widthFull sm-12" routerLink="/send-money">Send money now</button>
                    </div> -->
                    <div class="col-md-2 col-3 px-md-0">
                        <a *ngIf="auth.user?.country_id==233" class="sm-12 cursor-pointer primary-text"  data-toggle="modal" data-target="#us-invoice" (click)="assign(transaction.Transaction_id)">
                            Invoice
                        </a>
                    </div>
                    <div *ngIf="auth.user?.country_id==233" class="col-3 col-md-2 px-md-0">
                        <small><a class="text-danger cursor-pointer" data-toggle="tooltip" title="Cancel transaction" (click)="cancelTransaction(transaction.Transaction_id)">Cancel</a></small>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="transaction.status=='under_process' || transaction.status=='processing'">
                <div class="d-flex justify-content-between align-items-center p-3">
                    <div class="gilroy-bold pt-1 sm-10 color-blue">
                        <img src="assets/images/send_money_blue.PNG" alt="Send Money" class="mr-1" width="24px">
                        <!-- <i class="fa fa-money p-0 sm-16 mr-1"></i> -->
                        Send money
                    </div>
                    <div class="text-secondary sm-10">
                        
                        {{ common.carbonToJs(transaction.created) }} 
                        
                    </div>
                    <div class="gilroy-bold sm-10 text-warning">
                        PENDING 
                    </div>
                </div>
                <div class="d-flex justify-content-between p-3 align-items-center">
                    <div class="sm-12 gilroy-med">You are sending <span class="gilroy-bold color-blue">{{ transaction.receiver_amt }} {{ transaction.receiver_currency }}</span> to <span class="gilroy-bold color-blue">{{ transaction.first_name ? transaction.first_name : transaction.name}} {{ transaction.last_name }}</span></div>
                    <!-- <div>
                        <button  class="btn primary-btn px-3 btn-widthFull sm-12" routerLink="/send-money">Send money now</button>
                    </div> -->
                    <div *ngIf="auth.user?.country_id==233" class="col-3 col-md-2 px-md-0">
                        <small><a class="text-danger cursor-pointer" data-toggle="tooltip" title="Cancel transaction" (click)="cancelTransaction(transaction.Transaction_id)">Cancel</a></small>
                    </div>
                    <a *ngIf="auth.user?.country_id==233" class="sm-12 cursor-pointer primary-text"  data-toggle="modal" data-target="#us-invoice" (click)="assign(transaction.Transaction_id)">Invoice</a>
                </div>
            </ng-container>
            <ng-container *ngIf="transaction.status=='failed'">
                <div class="d-flex justify-content-between align-items-center p-3">
                    <div class="gilroy-bold pt-1 sm-10 color-blue">
                        <!-- <img src="assets/images/key.png" alt="" class="mr-1" width="16px"> -->
                        <!-- <i class="fa fa-money p-0 sm-16 mr-1"></i> -->
                        <img src="assets/images/send_money_blue.PNG" alt="Send Money" class="mr-1" width="24px">
                        Send money
                    </div>
                    <div class="text-secondary sm-10">
                        
                        {{ common.carbonToJs(transaction.created) }} 
                        
                    </div>
                    <div class="gilroy-bold sm-10 text-danger">
                        FAILED 
                    </div>
                </div>
                <div class="d-flex justify-content-between p-3 align-items-center">
                    <div class="sm-12 gilroy-med">Your transaction of <span class="gilroy-bold color-blue">{{ transaction.receiver_amt }} {{ transaction.receiver_currency }}</span> to <span class="gilroy-bold color-blue">{{ transaction.first_name ? transaction.first_name : transaction.name}} {{ transaction.last_name }}</span> has failed.</div>
                    <!-- <div>
                        <button  class="btn primary-btn px-3 btn-widthFull sm-12" routerLink="/send-money">Send money now</button>
                    </div> -->
                    <!-- Button trigger modal -->
                    <!-- <a *ngIf="auth.user?.country_id==233" class="sm-12 cursor-pointer primary-text"  data-toggle="modal" data-target="#us-invoice" (click)="assign(transaction.Transaction_id)">Invoice</a> -->
                </div>
            </ng-container>
            <ng-container *ngIf="transaction.status=='success'">
                <div class="d-flex justify-content-between align-items-center p-3">
                    <div class="gilroy-bold pt-1 sm-10 color-green">
                        <!-- <img src="assets/images/key.png" alt="" class="mr-1" width="16px"> -->
                        <!-- <i class="fa fa-money p-0 sm-16 mr-1"></i> -->
                        <img src="assets/images/send_money_green.PNG" alt="Send Money" class="mr-1" width="24px">
                        Send money
                    </div>
                    <div class="text-secondary sm-10">
                        
                        {{ common.carbonToJs(transaction.created) }} 
                        <!-- {{transaction.created | date}} -->
                        
                    </div>
                    <div class="gilroy-bold sm-10 color-green">
                        SUCCESSFUL 
                    </div>
                </div>
                <div class="d-flex justify-content-between p-3 align-items-center">
                    <div class="sm-12 gilroy-med">You have successfully sent <span class="gilroy-bold color-green">{{ transaction.receiver_amt }} {{ transaction.receiver_currency }}</span> to <span class="gilroy-bold color-green">{{ transaction.first_name ? transaction.first_name : transaction.name}} {{ transaction.last_name }}</span></div>
                    <!-- <div>
                        <button  class="btn primary-btn px-3 btn-widthFull sm-12" routerLink="/send-money">Send money now</button>
                    </div> -->
                    <a *ngIf="auth.user?.country_id==233" class="sm-12 cursor-pointer primary-text"  data-toggle="modal" data-target="#us-invoice" (click)="assign(transaction.Transaction_id)">Invoice</a>
                </div>
            </ng-container>
            <ng-container *ngIf="transaction.status=='COMPLETED'">
                <div class="d-flex justify-content-between align-items-center p-3">
                    <div class="gilroy-bold pt-1 sm-10 color-green">
                        <!-- <img src="assets/images/key.png" alt="" class="mr-1" width="16px"> -->
                        <!-- <i class="fa fa-money p-0 sm-16 mr-1"></i> -->
                        <img src="assets/images/send_money_green.PNG"  alt="Send Money" class="mr-1" width="24px">
                        Send money
                    </div>
                    <div class="text-secondary sm-10">
                        
                        {{ common.carbonToJs(transaction.created) }} 
                    </div>
                    <div class="gilroy-bold sm-10 color-green">
                        COMPLETED 
                    </div>
                </div>
                <div *ngIf="auth.user?.country_id==39" class="d-flex justify-content-between p-3 align-items-center">
                    <div class="sm-12 gilroy-med">You have successfully sent <span class="gilroy-bold color-green">{{ transaction.receiver_amt }} {{ transaction.receiver_currency }}</span> to <span class="gilroy-bold color-green">{{ transaction.first_name ? transaction.first_name : transaction.name}} {{ transaction.last_name }}</span></div>
                    <!-- <div>
                        <button  class="btn primary-btn px-3 btn-widthFull sm-12" routerLink="/send-money">Send money now</button>
                    </div> -->
                </div>
                <div  *ngIf="auth.user?.country_id==233" class="d-flex justify-content-between p-3 align-items-center">
                    <div class="sm-12 gilroy-med">You have successfully sent <span class="gilroy-bold color-green">{{ transaction.receiver_amt }} {{ transaction.receiver_currency }}</span> to <span class="gilroy-bold color-green">{{ transaction.first_name ? transaction.first_name : transaction.name}} {{ transaction.last_name }}</span></div>
                    <!-- Button trigger modal -->
                    <a class="sm-12 cursor-pointer primary-text"  data-toggle="modal" data-target="#us-invoice" (click)="assign(transaction.Transaction_id)" >Invoice</a>
                </div> 
            </ng-container>
            <ng-container *ngIf="transaction.status=='HOLD'">
                <div class="d-flex justify-content-between align-items-center p-3">
                    <div class="gilroy-bold pt-1 sm-10 color-green">
                        <!-- <img src="assets/images/key.png" alt="" class="mr-1" width="16px"> -->
                        <i class="fa fa-money p-0 sm-16 mr-1"></i>
                        Send money
                    </div>
                    <div class="text-secondary sm-10">
                        
                        {{ common.carbonToJs(transaction.created) }} 
                        
                    </div>
                    <div class="gilroy-bold sm-10 color-green">
                        ON HOLD 
                    </div>
                </div>
                <div class="d-flex justify-content-between p-3 align-items-center">
                    <div class="sm-12 gilroy-med">Your transfer of <span class="gilroy-bold color-blue">{{ transaction.receiver_amt }} {{ transaction.receiver_currency }}</span> to <span class="gilroy-bold color-blue">{{ transaction.first_name ? transaction.first_name : transaction.name}} {{ transaction.last_name }}</span> is on hold.</div>
                    <!-- <div>
                        <button  class="btn primary-btn px-3 btn-widthFull sm-12" routerLink="/send-money">Send money now</button>
                    </div> -->
                    <!-- <a *ngIf="auth.user?.country_id==233" class="sm-12 cursor-pointer primary-text"  data-toggle="modal" data-target="#us-invoice" (click)="assign(transaction.Transaction_id)">Invoice</a> -->
                </div>
            </ng-container>
            <ng-container *ngIf="transaction.status=='CANCEL_UNDER_PROCESS' ">
                <div class="d-flex justify-content-between align-items-center p-3">
                    <div class="gilroy-bold pt-1 sm-10 color-green col-4 p-0">
                        <!-- <img src="assets/images/key.png" alt="" class="mr-1" width="16px"> -->
                        <!-- <i class="fa fa-money p-0 sm-16 mr-1"></i> -->
                        <img src="assets/images/send_money_blue.PNG"  alt="" class="mr-1" width="24px">
                        Send money
                    </div>
                    <div class="text-secondary sm-10 col-4 p-0">
                        
                        {{ common.carbonToJs(transaction.created) }} 
                        
                    </div>
                    <div class="gilroy-bold sm-10 color-green text-right">
                        CANCELLED (UNDER PROGRESS) 
                    </div>
                </div>
                <div class="d-flex justify-content-between p-3 align-items-center">
                    <div class="sm-12 gilroy-med">Your cancelled transfer of <span class="gilroy-bold color-blue">{{ transaction.receiver_amt }} {{ transaction.receiver_currency }}</span> to <span class="gilroy-bold color-blue">{{ transaction.first_name ? transaction.first_name : transaction.name}} {{ transaction.last_name }}</span> is under process.</div>
                    <!-- <div>
                        <button  class="btn primary-btn px-3 btn-widthFull sm-12" routerLink="/send-money">Send money now</button>
                    </div> -->
                    <a *ngIf="auth.user?.country_id==233" class="sm-12 cursor-pointer primary-text"  data-toggle="modal" data-target="#us-invoice" (click)="assign(transaction.Transaction_id)">Invoice</a>
                </div>
            </ng-container>
            <ng-container *ngIf="transaction.status=='cancelled' || transaction.status=='CANCELED' ">
                <div class="d-flex justify-content-between align-items-center p-3">
                    <div class="gilroy-bold pt-1 sm-10 color-green">
                        <!-- <img src="assets/images/key.png" alt="" class="mr-1" width="16px"> -->
                        <!-- <i class="fa fa-money p-0 sm-16 mr-1"></i> -->
                        <img src="assets/images/send_money_blue.PNG"  alt="Send Money" class="mr-1" width="24px">
                        Send money
                    </div>
                    <div class="text-secondary sm-10">
                        
                        {{ common.carbonToJs(transaction.created) }} 
                        
                    </div>
                    <div class="gilroy-bold sm-10 text-danger">
                        CANCELLED 
                    </div>
                </div>
                <div class="d-flex justify-content-between p-3 align-items-center">
                    <div class="sm-12 gilroy-med">Your transfer of <span class="gilroy-bold color-blue">{{ transaction.receiver_amt }} {{ transaction.receiver_currency }}</span> to <span class="gilroy-bold color-blue">{{ transaction.first_name ? transaction.first_name : transaction.name}} {{ transaction.last_name }}</span> is cancelled.</div>
                    <!-- <div>
                        <button  class="btn primary-btn px-3 btn-widthFull sm-12" routerLink="/send-money">Send money now</button>
                    </div> -->
                    <a *ngIf="auth.user?.country_id==233" class="sm-12 cursor-pointer primary-text"  data-toggle="modal" data-target="#us-invoice" (click)="assign(transaction.Transaction_id)">Invoice</a>
                </div>
            </ng-container>
        </div>
        <div class="w-100 d-flex align-items-center justify-content-center justify-content-md-end my-2" *ngIf="last_page!=1">
            <button class="btn bg-alice sm-10 color-blue col-4 col-md-3 gilroy-bold" (click)="getTransactions(+current_page - 1)" [disabled]='prev_disabled'>
                <i class="fas fa-arrow-left mr-1"></i> Previous
            </button>
            <span class="col-2 text-center sm-10 gilroy-bold color-blue">{{ +current_page }}/{{ +last_page }}</span>
            <button class="btn bg-alice sm-10 color-blue col-4 col-md-3 gilroy-bold" (click)="getTransactions(+current_page + 1)" [disabled]='next_disabled'>
                Next <i class="fas fa-arrow-right ml-1"></i>
            </button>
            
        </div>
    </div>
    
    <div class="col-md-5 col-12 tab-pane fade" role="tabpanel" 
    id="requests"  aria-labelledby="request-tab">
    <div *ngIf="!requests.length">
        No requests found!
    </div>
    <ng-container *ngFor="let request of requests.slice(startRequest, startRequest + 10)">
        <div class="card border-0 verified-box d-flex align-items-between radius-5 my-2 mx-0">
            <div class="d-flex justify-content-between align-items-center p-3">
                <div class="gilroy-bold pt-1 sm-10 color-green">
                    <img src="assets/images/key_green.PNG"  alt="Verification" class="mr-1" width="24px">
                    <!-- <i class="fa fa-money p-0 sm-16 mr-1"></i> -->
                    Money Request
                </div>
                <div class="lightGrey-text sm-10">
                    {{request.created_at | date}}
                </div>
            </div>
            <div class="d-flex justify-content-between p-3 align-items-center">
                <div class="sm-12 color-green gilroy-bold">
                    {{request.name}} 
                    has requested 
                    {{request.amount}} {{auth.user.currency.toUpperCase()}}
                </div>
            </div>
            <div class="w-100 d-flex align-items-center justify-content-center justify-content-md-end my-2" *ngIf="requests.length!=0">
                <button class="btn bg-alice sm-10 color-blue col-4 col-md-3 gilroy-bold" (click)="prevRequest()" [disabled]='!startRequest'>
                    Previous
                </button>
                <span class="col-2 text-center sm-10 gilroy-bold color-blue">{{ startRequest/10 + 1 }}</span>
                <button class="btn bg-alice sm-10 color-blue col-4 col-md-3 gilroy-bold" (click)="nextRequest()" [disabled]='disableReqNext()'>
                    Next
                </button>
            </div>
            <div>
                <button  class="btn mx-1 primary primary-btn px-3 btn-widthFull sm-12" (click)="rejectMoneyRequest(request.id)">Reject</button>
                <button  class="btn mx-1 primary-btn px-3 btn-widthFull sm-12" (click)="approveMoneyRequest(request)">Send money</button>
                
            </div>
        </div>
    </ng-container>
    
</div>


</div>
</div>
</div>

